import { useState } from "react";
import { api, ApiError } from "../api";

/**
 * TROCA DE SENHA — obrigatória no primeiro acesso.
 *
 * A primeira senha é sorteada pelo DP e entregue à pessoa. Enquanto ela valer,
 * mais de uma pessoa sabe a senha — e num sistema de ponto isso significa que
 * mais de uma pessoa pode bater por você. Por isso a tela é intransponível
 * quando `obrigatoria`: não há botão de "depois".
 */

interface Props {
  /** Primeiro acesso: não dá para sair sem trocar. */
  obrigatoria: boolean;
  onTrocada: () => void;
  onCancelar?: () => void;
}

export default function TrocarSenha({ obrigatoria, onTrocada, onCancelar }: Props) {
  const [atual, setAtual] = useState("");
  const [nova, setNova] = useState("");
  const [confirma, setConfirma] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [salvando, setSalvando] = useState(false);

  async function salvar(e: React.FormEvent) {
    e.preventDefault();
    // Confere a digitação aqui: mandar para o servidor e voltar com "não
    // confere" custa uma ida à rede que na obra pode demorar.
    if (nova !== confirma) {
      setErro("A confirmação não confere com a nova senha.");
      return;
    }
    setErro(null);
    setSalvando(true);
    try {
      await api.trocarSenha(atual, nova);
      onTrocada();
    } catch (err) {
      setErro(err instanceof ApiError ? err.message : "Não foi possível trocar a senha.");
    } finally {
      setSalvando(false);
    }
  }

  return (
    <div className="login-tela">
      <form className="login-caixa" onSubmit={salvar}>
        <div className="login-marca">
          <h1>{obrigatoria ? "Crie sua senha" : "Trocar senha"}</h1>
          <p>
            {obrigatoria
              ? "A senha que o DP entregou serve só para este primeiro acesso."
              : "Escolha uma senha que só você saiba."}
          </p>
        </div>

        <label className="campo">
          <span>{obrigatoria ? "Senha que o DP entregou" : "Senha atual"}</span>
          <input
            type="password"
            autoComplete="current-password"
            value={atual}
            onChange={(e) => setAtual(e.target.value)}
            required
          />
        </label>

        <label className="campo">
          <span>Nova senha</span>
          <input
            type="password"
            autoComplete="new-password"
            placeholder="Pelo menos 6 caracteres"
            value={nova}
            onChange={(e) => setNova(e.target.value)}
            required
          />
        </label>

        <label className="campo">
          <span>Repita a nova senha</span>
          <input
            type="password"
            autoComplete="new-password"
            value={confirma}
            onChange={(e) => setConfirma(e.target.value)}
            required
          />
        </label>

        {erro && <div className="aviso-erro">{erro}</div>}

        <button className="botao-principal" type="submit" disabled={salvando}>
          {salvando ? "Salvando…" : "Salvar senha"}
        </button>

        {!obrigatoria && onCancelar && (
          <button type="button" className="botao-texto" onClick={onCancelar}>
            Cancelar
          </button>
        )}
      </form>
    </div>
  );
}
